const car = ['Cabrio', 'Coupe', 'Crossover', 'Fastback', 'Hardtop', 'Hatchback', 'Kombi', 'Liftback', 'Limuzyna', 'Minivan', 'Pickup', 'Roadster', 'Sedan', 'Sportowe', 'SUV', 'Targa', 'Zabytkowe', '7 osobowy', 'Poleasingowy', 'Inny']
const truck = [
    'Autobusy',
    'Autolaweta',
    'Chłodnia/Izoterma',
    // 'Ciężarowe',
    'Do zabudowy',
    'Doka',
    'Furgon',
    'Kamper Camper',
    'Kontener',
    'Mikrobus',
    'Pickup',
    'Plandeka',
    'Platformy',
    'Skrzynia',
    'Specjalny',
    'Van',
    'Wywrotka',
    '7 osobowy',
    'Poleasingowy',
    'Inny',
]
const motorcycle = ['Chopper', 'Krossowy', 'Cruiser', 'Enduro', 'Motorower', 'Naked', 'Quad', 'Skuter', 'Sportowy', 'Turystyczny', 'Prawo jazdy kat. B']
const trailer = [
    'Burtowa',
    'Chłodnia',
    'Cysterna',
    'Do przewozu zwierząt',
    'Do przewozu ludzi',
    'Do przewozu samochodów',
    'Firana',
    'Izoterma',
    'Kempingowa',
    'Laweta',
    'Pod kontener',
    'Rolnicza',
    'Towarowa',
    'Wywrotka',
    'Inna',
]
const heavy = [
    "Autolaweta",
    "Betonomieszarka",
    "Chłodnia i izotermy",
    "Ciągniki siodłowe",
    "Cysterna",
    "Dźwigi i żurawie",
    "Hakowe i bramowe",
    "Kontener",
    "Plandeka",
    "Podnośniki",
    "Podnośniki koszykowe",
    "Pojazdy do zabudowy",
    "Pojazdy użyteczności publicznej",
    "Pompa do betonu",
    "Skrzynia",
    "Specjalny",
    "Wywrotki",
    "Zestaw (ciągnika z naczepą)",
]

export default [...car,...truck,...motorcycle,...trailer,...heavy]
export {
    car,
    truck,
    motorcycle,
    trailer,
    heavy,
}